<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <label class="mb-0"><small>Nome</small></label>
        <input v-model="data.name" class="form-control" />
      </div>

      <div class="col-12 col-md-6">
        <label class="mb-0"><small>Video</small></label>
        <drop-media
          class="form-control"
          :media="data.video"
          @setMedia="setVideo"
          :type="['video']"
        />
      </div>

      <div class="col-12 col-md-6">
        <label class="mb-0"><small>Documento (Imagem ou Documento para download)</small></label>
        <drop-media
          class="form-control"
          :media="data.media"
          @setMedia="setDocument"
          :type="['image','application']"
        />
      </div>

      <div class="col-12">
        <label class="mb-0"><small>Descrição</small></label>
        <textarea class="form-control textarea" v-model="data.description"></textarea>
      </div>

      <div class="col-12 text-right mt-1">
        <button class="btn btn-sm btn-success" v-if="hasChanged" @click="save">Salvar</button>
        <button class="btn btn-sm btn-danger" @click="del">Excluir</button>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import DropMedia from './DropMedia'
import { Form } from 'vform'
import Axios from 'axios'

export default {
  components: {
    "drop-media": DropMedia
  },
  props: {
    data: {
      required: true
    },
    course: {
      required: true
    },
    module: {
      required: true
    },
    index: {
      required: true
    }
  },
  data () {
    return {
      originalData: undefined,
      form: new Form({
        id: undefined,
        course_id: undefined,
        course_module_id: undefined,
        name: '',
        image_media: undefined,
        video_media: undefined,
        pdf_media: undefined,
        description: ''
      })
    }
  },
  computed: {
    hasChanged: function () {
      return this.originalData !== JSON.stringify(this.data)
    }
  },
  methods: {
    setDocument: function ( item ) {
      this.data.media = item
    },

    setVideo: function ( item ) {
      this.data.video = item
    },

    del: function () {
      if ( this.data.id ) {
        Axios.delete('/teacher/course/leason', {
          data: {
            leason: this.data.id
          }
        })
      }
      this.$emit('delete', this.index)
    },

    save: function () {
    if ( this.data.id ) {
        this.form.id = this.data.id
      }

      this.form.course_id = this.course
      this.form.course_module_id = this.module
      this.form.name = this.data.name
      this.form.image_media = this.data.image
      this.form.video_media = this.data.video
      this.form.pdf_media = this.data.media
      this.form.description = this.data.description

      this.form.post('/teacher/course/leason')
        .then( res => {
          this.originalData = JSON.stringify(this.data)
          // this.load()
        })
        .catch( err => {
          console.error( err )
        })
    },
  },
  mounted () {
    this.originalData = JSON.stringify(this.data)
  }
}
</script>

<style>

</style>
